// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
import { ObjectSchema } from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormTask } from '~/utils/interface/task';

export const schema = (t: TFunction): ObjectSchema<IFormTask> => {
  return yup.object({
    businessId: yup.string().trim().optional(),
    businessType: yup.string().trim().optional(),
    title: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    description: yup.string().trim().optional(),
    assigneeIds: yup.array().optional(),
    dueDate: yup.string().trim().optional(),
    priority: yup.string().trim().optional(),
    status: yup.string().trim().optional(),
    tags: yup.array().optional(),
  });
};

export const defaultValuesTaskForm: IFormTask = {
  businessId: EMPTY_STRING,
  businessType: EMPTY_STRING,
  title: EMPTY_STRING,
  description: EMPTY_STRING,
  assigneeIds: [],
  dueDate: EMPTY_STRING,
  priority: EMPTY_STRING,
  status: EMPTY_STRING,
};
